import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import _ from "lodash";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class DateComponent extends Component {
  render() {
    return <span>{moment(this.props.data).format("DD.MM.YYYY")}</span>;
  }
}

class YesNoComponent extends Component {
  render() {
    return (
      <span>
        {this.props.data && "TAK"}
        {!this.props.data && "NIE"}
      </span>
    );
  }
}

class GroupsComponent extends Component {
  render() {
    let groups = "";

    if (!this.props.data) {
      return <div />;
    }

    for (let i = 0; i < this.props.data.length; i++) {
      groups += this.props.data[i].name;
      if (i != this.props.data.length - 1) {
        groups += ", ";
      }
    }

    return <span>{groups}</span>;
  }
}

class ActionComponent extends Component {
  openRemoveMediaCategoryModal = () => {
    const {
      openRemoveMediaCategoryModal
    } = this.props.metadata.customComponentMetadata;
    const row = this.props.rowData;
    openRemoveMediaCategoryModal(row.uid);
  };

  openEditMediaCategoryModal = () => {
    const {
      openEditMediaCategoryModal
    } = this.props.metadata.customComponentMetadata;
    const row = this.props.rowData;
    openEditMediaCategoryModal(row.uid);
  };

  render() {
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.openEditMediaCategoryModal}>edytuj</a>
              <br />
              <a onTouchTap={this.openRemoveMediaCategoryModal}>usuń</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired,
    mediaCategories: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onRowClick = (row, e) => {
    if (
      e.target.nodeName !== "INPUT" &&
      row.props.data.uid &&
      e.target.className !== "icon-table link" &&
      e.target.className !== "checkbox-in-table-label"
    ) {
      const { history } = this.props;
      history.pushState(
        "/mediaCategories/:uid",
        `/mediaCategories/${row.props.data.uid}`,
        {}
      );
    }
  };

  openRemoveMediaCategoryModal = uid => {
    const { actions } = this.props;
    actions.setIsRemoveMediaCategoryModalVisible(uid);
  };

  closeRemoveMediaCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveMediaCategoryModalVisible(false);
  };

  removeMediaCategory = () => {
    const {
      actions,
      notificationSystem,
      mediaCategories: {
        mediaCategories: { isRemoveModalVisible, meta: mediaCategoriesMeta }
      }
    } = this.props;
    actions
      .removeMediaCategory(isRemoveModalVisible)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          let notification = {
            level: "success",
            message: "Usunięto kategorię!",
            position: "br",
            autoDismiss: 5,
            dismissible: true
          };
          notificationSystem.addNotification(notification);
          actions
            .getMediaCategories(mediaCategoriesMeta)
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
        }
      });
    this.closeRemoveMediaCategoryModal();
  };

  openEditMediaCategoryModal = uid => {
    const { actions } = this.props;
    actions.setIsEditMediaCategoryModalVisible(uid);
  };

  closeEditMediaCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsEditMediaCategoryModalVisible(false);
  };

  editMediaCategory = () => {
    const {
      actions,
      notificationSystem,
      mediaCategories: {
        mediaCategories: {
          isEditModalVisible,
          meta: mediaCategoriesMeta,
          entities: mediaCategories
        }
      }
    } = this.props;

    actions
      .updateMediaCategory(
        mediaCategories.get(isEditModalVisible).toJS(),
        isEditModalVisible
      )
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions
            .getMediaCategories(mediaCategoriesMeta)
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              }
            });
        }
      });

    this.closeEditMediaCategoryModal();
  };

  render() {
    const {
      mediaCategories,
      mediaCategories: {
        mediaCategories: {
          isRemoveModalVisible,
          isEditModalVisible,
          loading,
          meta: { currentPage, limit }
        }
      },
      actions,
      tableWidth,
      tableHeight
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Nazwa kategorii",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "description",
        displayName: "Opis",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "createdAt",
        displayName: "Data dodania",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: DateComponent
      },
      {
        columnName: "updatedAt",
        displayName: "Ostatnie zmiany",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: DateComponent
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemoveMediaCategoryModal: this.openRemoveMediaCategoryModal,
          openEditMediaCategoryModal: this.openEditMediaCategoryModal
        }
      }
    ];

    let data = [];
    let index = 0;

    mediaCategories
      .getIn(["mediaCategories", "entities"])
      .forEach(function(mediaCategory) {
        mediaCategory = mediaCategory.toJS();
        index++;
        mediaCategory.index = index + currentPage * limit;
        data = data.concat(mediaCategory);
      });

    const editMediaCategoryProps = {
      actions: actions,
      entity: mediaCategories.getIn([
        "mediaCategories",
        "entities",
        isEditModalVisible
      ]),
      feature: "mediaCategories",
      uid: isEditModalVisible
    };

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={[
            "index",
            "name",
            "description",
            "createdAt",
            "updatedAt",
            "actions"
          ]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          noDataMessage={loading ? "" : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />

        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveMediaCategoryModal}
            enterAction={this.removeMediaCategory}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <div className="col-xs-12">
                <p>Czy napewno usunąć?</p>
                <button className="error" onClick={this.removeMediaCategory}>
                  Usuń
                </button>
              </div>
            </div>
          </Modal>
        )}

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditMediaCategoryModal}
            enterAction={this.editMediaCategory}
            handleKeyDownEvent={true}
          >
            <div className="row">
              <h3 className="col-xs-12">Edytuj media</h3>
              <div className="col-xs-12">
                <InputCustom
                  placeholder="Nazwa kategorii"
                  field={["name"]}
                  {...editMediaCategoryProps}
                />
              </div>
              <div className="col-xs-12">
                <InputCustom
                  placeholder="Opis kategorii"
                  field={["description"]}
                  {...editMediaCategoryProps}
                />
              </div>
              <div className="col-xs-12">
                <button className="info" onClick={this.editMediaCategory}>
                  Aktualizuj opis
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/mediaCategories/table.react.js